var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { useCallback, useContext, useEffect, useState } from "react";
import { PDFGenContext } from "./PDFGenerator";
import { api } from "../../api/API";
import { sleep } from "nate-react-api-helpers";
export function usePrintParallel() {
    var _this = this;
    var _a = useContext(PDFGenContext), isPrinting = _a.isPrinting, isPrintingRef = _a.isPrintingRef, print = _a.print;
    var _b = useState([]), queue = _b[0], setQueue = _b[1];
    var _c = useState([]), errors = _c[0], setErrors = _c[1];
    var _d = useState(0), loadingCount = _d[0], setLoadingCount = _d[1];
    var _e = useState(0), totalCount = _e[0], setTotalCount = _e[1];
    useEffect(function () { if (isPrinting)
        return; if (isPrintingRef.current)
        return; var item = queue.shift(); if (!item)
        return; (function () { return __awaiter(_this, void 0, void 0, function () { var done, content, info, status, e_1; return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                setLoadingCount(function (old) { return old + 1; });
                setTotalCount(function (old) { return old + 1; });
                done = function () { setLoadingCount(function (old) { return old - 1; }); };
                _a.label = 1;
            case 1:
                _a.trys.push([1, 8, , 9]);
                console.log("print: call()");
                return [4 /*yield*/, print(item.render, makeConfigurator(item.serverInfo, function (v) { item.serverInfo = v; }))];
            case 2:
                content = _a.sent();
                return [4 /*yield*/, api.print.print({ content: content, name: item.name, args: item.serverInfo ? JSON.stringify(item.serverInfo) : "" })];
            case 3:
                info = _a.sent();
                _a.label = 4;
            case 4:
                if (!true) return [3 /*break*/, 7];
                return [4 /*yield*/, sleep(1000)];
            case 5:
                _a.sent();
                return [4 /*yield*/, api.print.getStatus({ uuid: info.uuid })];
            case 6:
                status = _a.sent();
                if (status.failed) {
                    setErrors(function (old) { return __spreadArray(__spreadArray([], old, true), ["PDF failed: " + item.name], false); });
                    done();
                    return [2 /*return*/];
                }
                else if (status.ready) {
                    if (item.download) {
                        api.print.download({ uuid: info.uuid });
                    }
                    if (item.onComplete) {
                        item.onComplete({ print: info.uuid });
                    }
                    done();
                    return [2 /*return*/];
                }
                return [3 /*break*/, 4];
            case 7: return [3 /*break*/, 9];
            case 8:
                e_1 = _a.sent();
                setErrors(function (old) { return __spreadArray(__spreadArray([], old, true), [e_1.toString()], false); });
                done();
                if (item.onError) {
                    item.onError(e_1);
                }
                return [3 /*break*/, 9];
            case 9: return [2 /*return*/];
        }
    }); }); })(); }, [isPrinting, queue, loadingCount, print, isPrintingRef]);
    return { printer: useCallback(function (input) { setQueue(function (old) { return __spreadArray(__spreadArray([], old, true), [input], false); }); }, []), reset: useCallback(function () { setTotalCount(0); setErrors([]); setLoadingCount(0); }, []), loading: loadingCount > 0, errors: errors, loadingCount: loadingCount, totalCount: totalCount };
}
export function makeConfigurator(cfg, onChange) { var base = cfg; return { adjust: function (cb) { base = cb(base); onChange(base); } }; }
